var arr = [
  {
    title: 'الصفحة الرئيسية',
    route: 'home',
    icon: 'HomeIcon'
  },
  {
    title: 'الإشتراك في النظام',
    route: 'subscribe',
    icon: 'CheckSquareIcon',
    per: "*"
  },
  {
    title: 'الذكاء الإصطناعي',
    route: 'ai',
    icon: 'StarIcon',
    per: "ai"
  },
  {
    title: 'الاجهزة',
    route: 'devices',
    icon: 'ServerIcon',
    per: "devices"
  },
  {
    title: 'الطلبات',
    route: 'orders',
    icon: 'ShoppingBagIcon',
    per: "orders"
  },
  {
    title: 'الاحصائيات',
    route: 'stats',
    icon: 'PieChartIcon',
    per: "stats"
  },
  {
    title: 'سجل التحويلات',
    route: 'forwards',
    icon: 'CornerUpLeftIcon',
  },
  {
    title: 'الحسابات الفرعية',
    route: 'admins',
    icon: 'UsersIcon',
    per: "admins"
  },
  // {
  //   title: 'الردود الجاهزة',
  //   route: 'templates',
  //   icon: 'MessageSquareIcon',
  //   per: "templates"
  // },
  {
    title: 'تصنيفات العملاء',
    route: 'tags',
    icon: 'TagIcon',
    per: "tags"
  },
  {
    title: 'تطبيق الجوال',
    route: 'app',
    icon: 'SmartphoneIcon',
  },
  // {
  //   title: 'شرح الاستخدام',
  //   href: "https://youtu.be/j9IxSNr7sN4",
  //   icon: 'VideoIcon',
  // },
  {
    title: 'تسجيل الخروج',
    route: 'logout',
    icon: 'LogOutIcon'
  },
], arr2 = [], user = JSON.parse(localStorage.getItem("user"));

arr.forEach(function (e) {
  if(user?.pers){
    if(!e.per){
      arr2.push(e)
    }else{
      if(user.pers.includes("*") || user.pers.includes(e.per) || !e.per){
        arr2.push(e)
      }
    }
  }else{
    arr2.push(e)
  }
})

export default arr2
